import { render, staticRenderFns } from "./RecruitmentEdit.vue?vue&type=template&id=6abc5381"
import script from "./RecruitmentEdit.vue?vue&type=script&lang=js"
export * from "./RecruitmentEdit.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentEdit.vue?vue&type=style&index=0&id=6abc5381&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports